// src/components/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { useAuth }  from "../context/AuthContext";

export default function ProtectedRoute({ children, permission, role }) {
  const { user, loading, can, isRole } = useAuth();

  if (loading) {
    return (
      <div style={{
        display:"flex", alignItems:"center", justifyContent:"center",
        height:"100vh", background:"var(--bg-page)"
      }}>
        <div style={{textAlign:"center"}}>
          <div style={{
            width:40, height:40, border:"3px solid var(--border)",
            borderTopColor:"#D4A017", borderRadius:"50%",
            animation:"spin 0.8s linear infinite", margin:"0 auto 12px"
          }}/>
          <p style={{color:"var(--text-muted)", fontSize:13}}>Loading i-Panel...</p>
        </div>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  // Not logged in
  if (!user) return <Navigate to="/" replace />;

  // Role check
  if (role && !isRole(...(Array.isArray(role) ? role : [role]))) {
    return <AccessDenied />;
  }

  // Permission check
  if (permission && !can(permission)) {
    return <AccessDenied />;
  }

  return children;
}

function AccessDenied() {
  return (
    <div style={{
      display:"flex", alignItems:"center", justifyContent:"center",
      height:"100vh", background:"var(--bg-page)", flexDirection:"column", gap:12
    }}>
      <div style={{fontSize:48}}>🔒</div>
      <h2 style={{color:"var(--text-primary)", fontSize:20, fontWeight:700}}>Access Denied</h2>
      <p style={{color:"var(--text-secondary)", fontSize:14}}>
        You don't have permission to view this page.
      </p>
      <a href="/dashboard" style={{
        marginTop:8, padding:"8px 20px", borderRadius:8,
        background:"#D4A017", color:"#0A0A0F", fontWeight:700,
        fontSize:13, textDecoration:"none"
      }}>← Back to Dashboard</a>
    </div>
  );
}
